import { isOperationalRecoveryMode } from './operationalRecoveryFlags';

export function isRecoveryPersistenceMode(): boolean {
  const v = process.env.REACT_APP_RECOVERY_PERSISTENCE;
  if (v === 'false') return false;
  return v === 'true' || isOperationalRecoveryMode();
}

export function preferBackendCoordinationHydration(): boolean {
  const v = process.env.REACT_APP_BACKEND_COORDINATION_HYDRATION;
  if (v === 'false') return false;
  return v === 'true' || isRecoveryPersistenceMode();
}
